<!--
InputPassword Component — wraps PrimeVue Password for password fields.

Use for any password input (login, signup, change password). Forwards
all PrimeVue Password attrs and supports v-model.
-->

<template>
  <PrimePassword
    :id="elemId"
    v-model="internalValue"
    :placeholder="placeholder"
    :disabled="isDisabled"
    :feedback="feedback"
    :toggle-mask="toggleMask"
    :input-id="elemId"
    :autocomplete="autocomplete"
    fluid
    @update:modelValue="handleUpdate"
  />
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import PrimePassword from 'primevue/password';

interface Props {
  elemId?: string;
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean | string;
  feedback?: boolean;
  toggleMask?: boolean;
  autocomplete?: string;
}

const props = withDefaults(defineProps<Props>(), {
  elemId: undefined,
  modelValue: '',
  placeholder: '',
  disabled: false,
  feedback: false,
  toggleMask: true,
  autocomplete: 'new-password'
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const internalValue = ref<string>(props.modelValue ?? '');

const isDisabled = computed<boolean>(
  () => props.disabled === true || props.disabled === 'true'
);

const handleUpdate = (value: string): void => {
  emit('update:modelValue', value);
};

watch(() => props.modelValue, (next) => {
  internalValue.value = next ?? '';
});
</script>
